export default __webpack_public_path__ + "static/media/process-3.938da0e4.svg";